import styled from 'styled-components';

const PRIMARY = '#4948ac';
const HEADER_BG = '#5f5f5f';

export const Container = styled.div`
  width: 100%
  padding: 24px 32px;
  font-family: 'Inter', sans-serif;
  color: #444;
`;

export const Breadcrumb = styled.div`
  font-size: 14px;
  color: ${PRIMARY};
  margin-bottom: 8px;
`;

export const PageTitle = styled.h1`
  font-size: 36px;
  font-weight: 400;
  margin: 8px 0 24px;
`;

export const SectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 400;
  margin: 24px 0 12px;
`;

export const TableWrapper = styled.div`
  border-bottom: 3px solid #666;
  margin-bottom: 24px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Thead = styled.thead`
  background: ${HEADER_BG};
  color: #fff;
`;

export const Th = styled.th`
  padding: 12px;
  text-align: left;
  font-weight: 500;
  font-size: 14px;
`;

export const Tr = styled.tr``;

export const Td = styled.td`
  padding: 14px 12px;
  font-size: 14px;
  border-bottom: 1px solid #ccc;
`;

export const StatusCell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const StatusBar = styled.span`
  width: 4px;
  height: 22px;
  background: #2ecc71;
`;

export const LinkText = styled.span`
  color: ${PRIMARY};
  cursor: pointer;
  font-weight: 500;
`;

export const SortIcon = styled.span`
  margin-left: 6px;
  font-size: 10px;
`;
